var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9788 15.9003C19.9571 15.9003 20.8179 15.3327 21.2614 14.4745L25.9311 5.49075C26.0411 5.28093 26.0975 5.04429 26.0947 4.80424C26.092 4.56419 26.0303 4.32905 25.9157 4.12209C25.801 3.91514 25.6374 3.74353 25.4411 3.62426C25.2448 3.50499 25.0225 3.44219 24.7963 3.44207H5.49145L4.26533 0.673584H0V3.44207H2.60877L7.30454 13.9485L5.54363 17.326C4.59143 19.1809 5.84363 21.4372 7.8263 21.4372H23.4789V18.6687H7.8263L9.26112 15.9003H18.9788ZM6.73061 6.21055H22.5789L18.9788 13.1318H9.822L6.73061 6.21055ZM7.8263 22.8215C6.39147 22.8215 5.23057 24.0673 5.23057 25.59C5.23057 27.1126 6.39147 28.3584 7.8263 28.3584C9.26112 28.3584 10.4351 27.1126 10.4351 25.59C10.4351 24.0673 9.26112 22.8215 7.8263 22.8215ZM20.8701 22.8215C19.4353 22.8215 18.2744 24.0673 18.2744 25.59C18.2744 27.1126 19.4353 28.3584 20.8701 28.3584C22.3049 28.3584 23.4789 27.1126 23.4789 25.59C23.4789 24.0673 22.3049 22.8215 20.8701 22.8215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e961e5ed136ae3d7809a810fdffef5a9.svg";
export { ForwardRef as ReactComponent };